export const trackerArticleId = 197;
